import React, { useState } from "react";
import moment from "moment";
import { nanoid } from "nanoid";
import "react-datepicker/dist/react-datepicker.css";
import { NavLink } from "react-router-dom";
import { Activity } from "../../types";
import useActivities from "../../hooks/useActivities";
import Wrapper from "../../components/Layout/Wrapper";
import Button from "../../components/Button";
import Creatable from "react-select/creatable";
import useSessions from "../../hooks/useSessions";
import { Input } from "antd";
import useAuth from "../../hooks/useAuth";

const DEFAULT_ACTIVITY: Activity = {
  id: "",
  name: "",
  description: "",
  startTime: +moment(),
  finishTime: +moment().add(1, "week"),
  stars: 150,
  isVisible: false,
  teachers: [],
  resources: [],
  acceptString: true,
  acceptUpload: false,
};

const Activities = () => {
  const [courseFilter, setCourseFilter] = useState("");
  const { isSuperUser } = useAuth();
  const [newActivity, setNewActivity] = useState({ name: "", course: "" });
  const {
    isLoading,
    error,
    data,
    addActivityToFirestore,
    removeActivity,
  } = useActivities();
  const { courses } = useSessions();

  const onAddActivity = () => {
    if (newActivity.name) {
      addActivityToFirestore({
        ...DEFAULT_ACTIVITY,
        id: nanoid(),
        name: newActivity?.name || "New activity",
        course: newActivity.course,
      });
    }
  };

  if (isLoading) {
    return <div>Loading</div>;
  }

  if (error) {
    return <div>ERROR: {JSON.stringify(error)}</div>;
  }

  if (!data) {
    return <div>No data</div>;
  }

  return (
    <div>
      <Wrapper style={{ flexDirection: "column", marginTop: 32 }}>
        <h1>Activities</h1>
        <Creatable
          style={{ width: 160 }}
          isClearable
          placeholder="Filter by course"
          value={
            courseFilter
              ? {
                  value: courseFilter || "",
                  label: courseFilter || "",
                }
              : undefined
          }
          options={courses?.map((x) => ({ value: x, label: x }))}
          onChange={(course) => {
            setCourseFilter(course?.value || "");
            setNewActivity({ ...newActivity, course: course?.value || "" });
          }}
        />
        <table className="yc-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Course</th>
              <th>Stars</th>
              <th>Submission type</th>
              <th>Teachers</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data
              .filter((x) => (courseFilter ? x.course === courseFilter : true))
              .map((activity) => (
                <tr key={activity.id}>
                  <td>
                    <NavLink to={`/activity/${activity.id}`}>
                      {activity.name}
                    </NavLink>
                  </td>
                  <td>{activity.course}</td>
                  <td>{activity.stars}</td>
                  <td>
                    {activity.acceptString && "string"}{" "}
                    {activity.acceptUpload && "file"}
                  </td>
                  <td>{(activity.teachers || []).length} teacher(s)</td>
                  <td>
                    {isSuperUser && (
                      <Button
                        small
                        variant="secondary"
                        onClick={() => removeActivity(activity.id)}
                      >
                        Remove
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            <tr>
              <td>
                <Input
                  placeholder="Activity Name"
                  value={newActivity.name}
                  autoFocus
                  onKeyDown={(e) => {
                    if (e.key === "Enter") onAddActivity();
                  }}
                  onChange={(e) =>
                    setNewActivity({ ...newActivity, name: e.target.value })
                  }
                />
              </td>
              <td>
                <Creatable
                  isClearable
                  placeholder="Course"
                  value={
                    newActivity.course
                      ? {
                          value: newActivity.course || "",
                          label: newActivity.course || "",
                        }
                      : undefined
                  }
                  options={courses?.map((x) => ({ value: x, label: x }))}
                  onChange={(course) => {
                    setNewActivity({
                      ...newActivity,
                      course: course?.value || "",
                    });
                  }}
                />
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <Button small variant="secondary" onClick={onAddActivity}>
                  Add
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </Wrapper>
    </div>
  );
};

export default Activities;
